// import { Box, Button, Typography, Modal, Grid } from "@mui/material";

import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  FormControl,
  Container,
  Grid,
  Box,
  Stack,
  OutlinedInput,
  InputLabel,
  MenuItem,
  ListItemText,
  Select,
  Checkbox,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  Modal,
  DialogTitle,
  Tabs,
  Tab,
  Switch,
  FormGroup,
  InputAdornment,
  Divider,
  DialogActions,
  IconButton,
} from "@mui/material";

import {
  DeductionUp,
  adDeduction,
  addEmployee,
  getNewSubscriptionReachageDetails,
  updateEmployee,
} from "./appoinmentDashboardApi";
import { payloadDateFormat, swalAlertPopProps } from "../../utils/commonUtils";
import { getDataRechageDetail } from "./smbAccountRechargeCustomApiHandler";
import { getMonthDifference } from "./smbAccounrReachargeDateFunction";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";

import { getAlldetailSerice } from "../services/servicesListApi";

// import "./test.css";

import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
// import { bookApoinment } from "./asppoinmentApi";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { routePath } from "../../constants/routePath";
import { setSession } from "../../utils/commonUtils";
import { setCustomerAppointmentId } from "../../app/store/reducer";
// import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { TextFieldSearch } from "../../common/fieldText";
import PoprchModal from "../payment/popSearch";
import Swal from "sweetalert2";
import { ModalHeader } from "../../common/modalHeader";
// import { getAlldetailSerice } from "../services/servicesListApi";
import calendar from "../../assets/icon/calendarblack.png";

dayjs.extend(utc);
dayjs.extend(timezone);

export default function FormModalT({
  open,
  setOpen,
  modalData,
  setModalData,
  getAll,
}) {
  const [pagination, setPagination] = useState({ page: 1, total: 10 });
  const [subscription, setSubscription] = useState();
  const [value, setValue] = React.useState("personalInfo");

  const handleChange_Tab = (event, newValue) => {
    // setPageNo(1);

    setValue(newValue);
  };

  const onClose = () => {
    if (modalData) {
      modalData = "";
    }
    setOpen(false);
  };

  const struct = {
    employeeId: "",
    courseName: "",
    durationInYear: "",
    passoutDate: "",
    courseDetails: "",
    percentage: "",
    grade: "",
    university: "",
    institute: "",
  };
  const [validationMsgFlag, setValidationMsgFlag] = useState(null);

  const appnType = useSelector((state) => state.reducer.apppoinmentUerType);
  const dispatch = useDispatch();
  const info = useSelector((state) => state.reducer.detail);
  const [formData, setFormData] = useState({ ...struct });

  useEffect(() => {
    console.log("formate date  ", timeValue);
    console.log("formData ", formData);
  }, [formData]);
  // const [default, setDateValue] = useState(dayjs().startOf('day'));

  const [dateValue, setDateValue] = useState(dayjs());
  const [dateValuet, setDateValuet] = useState();
const [passoutDateError, setPassoutDateError] = useState(false);

  const [timeValue, setTimeValue] = useState(dayjs());
  const [otpEnabled, setOtpEnabled] = useState(true);

  const handleChange = (e) => {
    const { name, value } = e.target;
    // console.log()
    if (typeof value == "object") {
      setFormData({
        ...formData,
        [name]: value[0],
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const setDate = (newValue) => {
    setDateValue(newValue);

    // const date = dayjs(newValue).tz('UTC').format('YYYY-MM-DDTHH:mm:ss.SSZ');

    // console.log("date ",date)

    const date = dayjs(newValue).tz("UTC").format("YYYY-MM-DDTHH:mm:ss");

    console.log("date", date);

    // console.log("data ",date)
    setFormData((prev) => {
      return { ...prev, passoutDate: date };
      // return {...prev,date:date}
    });
  };
  useEffect(() => {
    // setDate(dateValue); // Set the default date when open changes
    setFormData((prev) => {
      return {
        ...prev,
        passoutDate: dayjs(dateValue).format("YYYY-MM-DDTHH:mm:ss"), // Assuming dateValue is passed
      };
    });
  }, [open]);

  const setDatet = (newValue) => {
    setDateValuet(newValue);

    // const date = dayjs(newValue).tz('UTC').format('YYYY-MM-DDTHH:mm:ss.SSZ');

    // console.log("date ",date)

    const date = dayjs(newValue).tz("UTC").format("YYYY-MM-DDTHH:mm:ss");

    console.log("date", date);

    // console.log("data ",date)
    setFormData((prev) => {
      return { ...prev, passoutDate: date };
      // return {...prev,date:date}
    });
  };

  const setTime = (newValue) => {
    setFormData((prev) => {
      if (newValue["$H"] == 20) {
        prev.hour = newValue["$H"] + 12;
      } else {
        prev.hour = newValue["$H"];
      }
      prev.minute = newValue["$m"];
      return { ...prev };
    });
    setTimeValue(newValue);
  };

  const handleTagsChange = (e) => {
    const { value } = e.target;

    console.log("val8e ", value);
    setFormData({
      ...formData,
      service: value,
    });
  };

  const gender = (e) => {
    setFormData((prev) => {
      let temp = { ...prev };
      if (e.target) {
        temp.gender = e.target.value;
      } else {
        temp.gender = e;
      }
      return { ...temp };
    });
  };

  const handleVerifymobileNumber = () => {
    if (formData.mobileNumber) {
      setOtpEnabled(true);
    }
  };

  const navigate = useNavigate();
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(appnType, "appnType");

    if (!search?.name) {
      Swal.fire({
        text: "please select ",
        icon: "warning",
        ...swalAlertPopProps,
      });
      setValidationMsgFlag(true);
      setOpen(false);
    } else {
      setValidationMsgFlag(null);
      const formDataobj = new FormData();
      Object.keys(formData).forEach((key, index) => {
        formDataobj.append(key, formData[key]);
      });
      const condition = appnType == "profile";
      const payload = {
        ...formData,
        empId: parseInt(search?.id),
        // empId: formData.employeeId,
        durationInYear: parseFloat(formData?.durationInYear),
        percentage: formData.percentage.includes(".")
          ? Number(formData.percentage)
          : Number(formData.percentage + ".00"),

        // "aadhar": formData?.aadhar
      };

      console.log("formdata", payload, " ", payload?.paymentPercentage);
      if (!formData?.id) {
        adDeduction(payload, () => {
          setOpen(false);
          getAll();
          // console.log("payload",)
        });
      } else {
        payload["id"] = modalData?.id;
        DeductionUp(payload, () => {
          getAll();
          setOpen(false);
          // getAll();
        });
      }
      if (!formData.passoutDate) {
        setPassoutDateError(true);
        return;
      } else {
        setPassoutDateError(false);
      }
    }
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  const [servicesArr, setservicesArr] = useState([
    {
      serviceName: "Shaving",
      rate: "100.00/Per Head",
    },
    {
      serviceName: "Hair cutting",
      rate: "150.00/Per Head",
    },
  ]);
  const names = [
    "Haircut",
    "Hair Coloring",
    "Hair Styling",
    "Manicure",
    "Pedicure",
    "Facial",
    "Waxing",
    "Massage",
    "Makeup",
    "Bridal Makeup",
    "Threading",
    "Hair Spa",
    "Nail Art",
    "Skin Treatment",
  ];
  useEffect(() => {
    setFormData({
      ...formData,
      billerId: info.billerId,
    });
    setDate(timeValue);
    setTime(timeValue);
    gender("male");
  }, []);

  const infoD = useSelector((state) => state.reducer.detail);
  useEffect(() => {
    // getAlldetailSerice(
    //   {
    //     billerId: infoD?.billerId,
    //   },
    //   (res) => {
    //     console.log("Data res", res);
    //     setservicesArr(res?.data);
    //   }
    // );
  }, []);

  const [search, setSearchvalue] = useState("");
  const [searchModal, setSearchModal] = useState(false);
  const [cardValue, setCardValue] = useState(null);

  useEffect(() => {
    if (open === true && modalData) {
      console.log("modalData", modalData);
      setFormData({
        ...formData,

        id: modalData?.id,
        employeeId: modalData?.employeeId,
        courseName: modalData?.courseName,
        durationInYear: modalData?.durationInYear,
        passoutDate: modalData?.passoutDate,
        courseDetails: modalData?.courseDetails,
        percentage: modalData?.percentage ? String(modalData?.percentage) : "",
        grade: modalData?.grade,
        university: modalData?.university,
        institute: modalData?.institute,
      });
      setSearchvalue({ name: modalData?.employeeName, id: modalData?.empId });
      // setSearchvalue({ name: modalData?.employeeName, id: modalData?.id });
      setDateValue(dayjs(modalData?.passoutDate));
      setDateValuet(dayjs(modalData?.passoutDate));

      // setDateValuet()
      // getDataRechageDetail(getNewSubscriptionReachageDetails, setSubscription);
    } else {
      console.log("close");
      if (!validationMsgFlag) {
        setFormData({ ...struct });
        setSearchvalue("");
      }
      setModalData(null);
      // setFormData({ ...struct });
    }
  }, [open]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      fullWidth={true}
      maxWidth="xs"
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          background: "white",
          width: { xs: "95%", sm: "85%", md: "70%", lg: "50%", xl: "50%" },
          overflowY: "auto",
          // height: "65vh",
          position: "absolute",
          borderRadius: "10px",
          left: { xs: "2%", sm: "10%", md: "20%", lg: "20%", xl: "25%" },
          top: { sm: "15%", xs: "5%" },
        }}
      >
        <ModalHeader title="Employee Educational Details" onClose={onClose} />

        <Box sx={{ p: 2 }} display="flex" justifyContent="center">
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <React.Fragment>
                <Grid xs={12} item>
                  <TextField
                    value={search?.name || ""}
                    placeholder="Search Employee"
                    size="small"
                    fullWidth
                    variant="outlined"
                    onClick={() => setSearchModal(true)}
                    sx={{
                      width: "100%",
                      backgroundColor: "white",
                      borderRadius: "6px",
                      // color: "#555555",
                      "& .MuiOutlinedInput-root": {
                        border: "#01008BA8",
                      },
                      "& .MuiInputBase-input::placeholder": {
                        color: "#555555",
                        opacity: 6,
                        fontWeight: 500,
                        cursor: "pointer",
                      },
                    }}
                    InputLabelProps={{
                      className: "mulish",
                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                    InputProps={{
                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                      readOnly: true,
                      endAdornment: (
                        <InputAdornment position="end">
                          {search?.name ? (
                            <CloseIcon
                              onClick={(e) => {
                                e.stopPropagation();
                                setSearchvalue("");
                                setCardValue(null);
                              }}
                            />
                          ) : (
                            <SearchIcon
                              color="primary"
                              sx={{ cursor: "pointer" }}
                            />
                          )}
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                {/* <h1>hiuh</h1> */}

                <PoprchModal
                  cardValue={cardValue}
                  setCardValue={(data) => {
                    setSearchvalue(data);
                    setFormData({ ...formData, employeeId: data?.id });
                    setCardValue(data);
                  }}
                  callback={() => {}}
                  searchModal={searchModal}
                  setSearchModal={setSearchModal}
                />

                {/* <Grid item xs={12} sm={12}>
                      <FormControl fullWidth >
                        <TextField
                          label="Employee Id"
                          name="employeeId"
                          value={formData.employeeId}
                          onChange={handleChange}
                          required
                          InputLabelProps={{ className: "mulish" }}
                          InputProps={{ classes: { input: "mulish" } }}
                        />
                      </FormControl>
                    </Grid>
                     */}

                <Grid item xs={12} sm={5}>
                  <FormControl fullWidth>
                    <TextField
                      label="Course Name :"
                      name="courseName"
                      size="small"
                      value={formData.courseName}
                      onChange={handleChange}
                      onInput={(e) =>
                        (e.target.value = e.target.value.replace(/^\w/, (c) =>
                          c.toUpperCase()
                        ))
                      }
                      required
                      InputProps={{
                        className: "mulish",

                        sx: {
                          background: "#fff",
                          borderRadius: 1,
                          cursor: "pointer",
                          fontFamily: "'Montserrat', sans-serif",
                          fontWeight: 500,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        },
                      }}
                      InputLabelProps={{
                        className: "mulish",

                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <FormControl fullWidth>
                    <TextField
                      label="Duration :"
                      name="durationInYear"
                      size="small"
                      value={formData.durationInYear}
                      // onInput={(e) => {
                      //   let inputValue = e.target.value.replace(/\D/g, "");
                      //   inputValue = inputValue.slice(0, 10);
                      //   e.target.value = inputValue;
                      // }}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      required
                      InputProps={{
                        className: "mulish",

                        sx: {
                          background: "#fff",
                          borderRadius: 1,
                          cursor: "pointer",
                          fontFamily: "'Montserrat', sans-serif",
                          fontWeight: 500,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        },
                      }}
                      InputLabelProps={{
                        className: "mulish",

                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <FormControl fullWidth>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label={
                          <span>
                            Passout Date:{" "}
                            <span style={{ color: "red" }}>*</span>
                          </span>
                        }
                        size="small"
                        value={modalData?.id ? dateValue : null}
                        // minDate={dayjs()}
                        required
                        onChange={(newValue) => {
                          setDate(newValue);
                          if (newValue) setPassoutDateError(false);
                        }}
                        slotProps={{
                          textField: {
                            size: "small",
                            error: passoutDateError,
                            helperText: passoutDateError
                              ? "Passout Date is required"
                              : "",
                            fullWidth: true,
                            InputLabelProps: {
                              className: "mulish",
                              sx: {
                                color: "#545454",
                                fontWeight: 400,
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                                paddingX: "7px",
                              },
                            },
                            InputProps: {
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton edge="end">
                                    <Box
                                      component="img"
                                      src={calendar}
                                      alt="calendar icon"
                                      sx={{
                                        width: 20,
                                        height: 20,
                                        cursor: "pointer",
                                      }}
                                    />
                                  </IconButton>
                                </InputAdornment>
                              ),
                              classes: { input: "mulish" },
                              sx: {
                                color: "#545454",
                                fontWeight: 400,
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                                paddingX: "7px",
                              },
                            },
                          },
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            fullWidth
                            InputLabelProps={{ className: "mulish" }}
                            InputProps={{ classes: { input: "mulish" } }}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={5}>
                  <FormControl fullWidth>
                    <TextField
                      label="Course Details :"
                      name="courseDetails"
                      size="small"
                      value={formData.courseDetails}
                      onChange={handleChange}
                      required
                      InputProps={{
                        className: "mulish",

                        sx: {
                          background: "#fff",
                          borderRadius: 1,
                          cursor: "pointer",
                          fontFamily: "'Montserrat', sans-serif",
                          fontWeight: 500,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        },
                      }}
                      InputLabelProps={{
                        className: "mulish",

                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                    />
                  </FormControl>
                </Grid>
              </React.Fragment>

              <React.Fragment>
                <Grid item xs={12} sm={4}>
                  <FormControl fullWidth>
                    <TextField
                      label=" Percentage :"
                      name="percentage"
                      size="small"
                      value={formData.percentage}
                      onChange={(e) => {
                        const inputValue = e.target.value;

                        // Regular expression to allow only numbers and one decimal point
                        const regex = /^[0-9]*\.?[0-9]*$/;

                        // Check if the input matches the regex
                        if (regex.test(inputValue)) {
                          // setValue(inputValue);
                          handleChange(e);
                        }
                      }}
                      required
                      InputProps={{
                        className: "mulish",

                        sx: {
                          background: "#fff",
                          borderRadius: 1,
                          cursor: "pointer",
                          fontFamily: "'Montserrat', sans-serif",
                          fontWeight: 500,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        },
                      }}
                      InputLabelProps={{
                        className: "mulish",

                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={3}>
                  {" "}
                  <FormControl fullWidth>
                    <TextField
                      label="Grade :"
                      name="grade"
                      size="small"
                      value={formData.grade}
                      onChange={handleChange}
                      required
                      InputProps={{
                        className: "mulish",

                        sx: {
                          background: "#fff",
                          borderRadius: 1,
                          cursor: "pointer",
                          fontFamily: "'Montserrat', sans-serif",
                          fontWeight: 500,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        },
                      }}
                      InputLabelProps={{
                        className: "mulish",

                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  {" "}
                  <FormControl fullWidth>
                    <TextField
                      label="University / Board Name :"
                      name="university"
                      size="small"
                      value={formData.university}
                      onInput={(e) =>
                        (e.target.value = e.target.value.replace(/^\w/, (c) =>
                          c.toUpperCase()
                        ))
                      }
                      onChange={handleChange}
                      required
                      InputProps={{
                        className: "mulish",

                        sx: {
                          background: "#fff",
                          borderRadius: 1,
                          cursor: "pointer",
                          fontFamily: "'Montserrat', sans-serif",
                          fontWeight: 500,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        },
                      }}
                      InputLabelProps={{
                        className: "mulish",

                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  {" "}
                  <FormControl fullWidth>
                    <TextField
                      label="Institute / College Name :"
                      name="institute"
                      size="small"
                      value={formData.institute}
                      onInput={(e) =>
                        (e.target.value = e.target.value.replace(/^\w/, (c) =>
                          c.toUpperCase()
                        ))
                      }
                      onChange={handleChange}
                      required
                      InputProps={{
                        className: "mulish",

                        sx: {
                          background: "#fff",
                          borderRadius: 1,
                          cursor: "pointer",
                          fontFamily: "'Montserrat', sans-serif",
                          fontWeight: 500,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        },
                      }}
                      InputLabelProps={{
                        className: "mulish",

                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                    />
                  </FormControl>
                </Grid>
              </React.Fragment>

              <Grid item xs={12}>
                <Divider
                  sx={{
                    borderColor: "#4E4E4E",
                    borderBottomWidth: 1,
                    marginTop: 2,
                    marginBottom: 1,
                  }}
                />
                <DialogActions
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <Button
                    type="submit"
                    sx={{
                      width: "70%",
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    }}
                    variant="contained"
                  >
                    {modalData?.id ? "Update" : "Save"}
                  </Button>
                </DialogActions>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Box>
    </Modal>
  );
}
